import script from "./HeroFeatures.vue?vue&type=script&setup=true&lang=js"
export * from "./HeroFeatures.vue?vue&type=script&setup=true&lang=js"

import "./HeroFeatures.vue?vue&type=style&index=0&id=2a209d4e&scoped=true&lang=css"
import "./HeroFeatures.vue?vue&type=style&index=1&id=2a209d4e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a209d4e"]])

export default __exports__